<template>
    <v-sheet class="d-flex flex-column align-center">
        <v-icon
            :color="feedback_color"
            class="my-8"
            size="72"
        >
            {{ feedback_icon }}
        </v-icon>
        <div class="text-h6 bold text-center px-4">{{ title }}</div>

        <div style="max-width: 400px">
            <div class="text-body-1 pa-4">
                {{ text }}
            </div>
        </div>
        <v-spacer />
        <v-btn
            @click="$emit('close')"
            class="mb-12"
            variant="outlined"
        >
            {{ public_url ? translate('common.close') : translate('common.return_to_debts') }}
        </v-btn>
    </v-sheet>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'
import { mapActions, mapState } from 'vuex'
import { api_mixin } from '@old/mixins/api_mixin'

export default {
    name: 'PaymentFeedback',
    props: {
        feedback: {
            type: String,
        },
        public_url: {
            type: Boolean,
        },
    },
    mixins: [api_mixin, locales_mixin],
    components: {},
    emits: ['close'],
    data() {
        return {}
    },
    computed: {
        feedback_icon() {
            switch (this.feedback) {
                case 'paid':
                    return 'mdi-checkbox-marked-circle-outline'
                case 'already_paid':
                    return 'mdi-checkbox-marked-circle-outline'
                case 'failed':
                    return 'mdi-alert-octagon-outline'
                case 'canceled':
                    return 'mdi-alert-octagon-outline'
                case 'pending':
                    return 'mdi-dots-horizontal-circle-outline'
                default:
                    return null
            }
        },
        feedback_color() {
            switch (this.feedback) {
                case 'paid':
                    return 'success'
                case 'already_paid':
                    return 'success'
                case 'failed':
                    return 'error'
                case 'canceled':
                    return 'error'
                case 'pending':
                    return 'neutral'
                default:
                    return null
            }
        },
        title() {
            return this.translate(`common.payment_${this.feedback}_title`)
        },
        text() {
            return this.translate(`common.payment_${this.feedback}_text`)
        },
        ...mapState(['payment']),
    },
    watch: {},
    methods: {
        async update_ocr() {
            const response = await this.api_get({
                url: `/ocr-numbers/${this.payment.print_document.ocr_number}`,
            })
            await this.update_key_in_state_property({
                property: 'payment',
                data: response.data,
                key: 'ocr',
            })
        },
        ...mapActions(['update_key_in_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        if (!this.public_url) this.update_ocr()
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
